<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h1 mat-dialog-title cdkDragHandle>Dear customer:</h1>
  <div mat-dialog-content>
    <p>
      All the applicability answers related will be removed. Are you sure to
      cancel all the topics?
    </p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancelClick()">Cancel</button>
    <button mat-button (click)="onConfirmClick()">Confirm</button>
  </div>
</div>
